import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function getHotelLicencesList(hotelId = null, hotelList = null) {
  const {
    host,
    URIs: { getHotelLicencesList },
  } = apiConfig;

  const uri = `${host}${getHotelLicencesList}`;

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  let searchCriteria = {
    hotelReference: 'civitfun',
    accessToken: storedCredentials.accessToken,
  };

  if (hotelId) searchCriteria.hotelId = hotelId;
  if (hotelList) searchCriteria.hotelList = hotelList;

  return axios
    .post(uri, {
      searchCriteria,
    })
    .then(res => {
      return res.data;
    });
}
